import { Button } from '@/components/ui/button';
import useGeneratorStore, { R3imagineStatusType, RecordingStatusEnum } from '@/state/generator-store';

export default function WarningModal() {
  const { setR3ImageStatus, setRecordingStatus } = useGeneratorStore();

  const handleRecordAgain = () => {
    setR3ImageStatus(R3imagineStatusType.WaitingUpload);
    setRecordingStatus(RecordingStatusEnum.WaitingRecording);
  };

  const handleUseUpload = () => {
    setR3ImageStatus(R3imagineStatusType.WaitingAgree);
  };

  return (
    <div className="w-full h-[320px] max-w-md p-4 bg-[#161718] rounded-lg flex flex-col">
      <div className="bg-[#393a3a] rounded-t-lg flex-1">
        <p className="text-[1rem] text-white p-4">
          Warning, recording a sound will remove your uploaded track. Are you sure you want to continue?
        </p>
      </div>
      <div className="mt-1">
        <div className="flex gap-1">
          <Button onClick={handleRecordAgain} className="bg-[#1d1d1f] flex-1 py-3 rounded-bl-lg text-sm text-white hover:bg-zinc-700">
            Cancel
          </Button>
          <Button onClick={handleUseUpload} className="bg-[#393a3a] flex-1 py-3 rounded-br-lg text-sm text-white hover:bg-zinc-700">
            Continue
          </Button>
        </div>
      </div>
    </div>
  );
}
